(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.References = {
    init: function () {
      var root = document.querySelector("[data-references]");
      if (!root || root.getAttribute("data-references-init") === "1") return;
      root.setAttribute("data-references-init", "1");

      var sliderEl = root.querySelector("[data-ref-slider]");
      var counter = root.querySelector("[data-ref-counter]");
      var prev = root.querySelector("[data-ref-prev]");
      var next = root.querySelector("[data-ref-next]");

      if (sliderEl && window.Swiper) {
        var swiper = new window.Swiper(sliderEl, {
          slidesPerView: 1.87,
          spaceBetween: 30,
          speed: 600,
          breakpoints: {
            0: { slidesPerView: 1.05 },
            768: { slidesPerView: 1.3 },
            1024: { slidesPerView: 1.87 }
          },
          on: {
            init: updateCounter,
            slideChange: updateCounter
          }
        });

        function updateCounter(sw) {
          if (counter) counter.textContent = (sw.activeIndex + 1) + " / " + sw.slides.length;
        }

        if (prev) prev.addEventListener("click", function () { swiper.slidePrev(); });
        if (next) next.addEventListener("click", function () { swiper.slideNext(); });
      }

      // Sub-sliders (3 per view, not loop)
      root.querySelectorAll("[data-ref-sub]").forEach(function (sub) {
        var track = sub.querySelector("[data-ref-sub-track]");
        var items = sub.querySelectorAll("[data-ref-sub-item]");
        var p = sub.querySelector("[data-ref-sub-prev]");
        var n = sub.querySelector("[data-ref-sub-next]");
        var index = 0;
        var perView = 3;
        var maxIndex = Math.max(0, items.length - perView);

        function update() {
          if (!track || !items.length) return;
          var w = items[0].offsetWidth;
          track.style.transform = "translateX(" + (-index * w) + "px)";
          if (p) p.disabled = index <= 0;
          if (n) n.disabled = index >= maxIndex;
        }

        if (p) p.addEventListener("click", function () { index = Math.max(0, index - 1); update(); });
        if (n) n.addEventListener("click", function () { index = Math.min(maxIndex, index + 1); update(); });
        update();
        window.addEventListener("resize", update);
      });
    }
  };
})(window, document);
